import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useMenusTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
